import { Dialog } from "primereact/dialog";
import { EmptyWorkstreamMasterDocument, IWorkstreamMasterDocument } from "./RFP_Workstream_Master_Documents";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { JVInput } from "../../../shared/JVInput";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { JVDropdown } from "../../../shared/JVDropdown";

interface IProps {
  singleData: IWorkstreamMasterDocument;
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
}

const schema = yup.object({});

export const Form = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [file, setFile] = useState<File | null>(null);
  const [categories, setCategories] = useState<any[]>([]);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm<IWorkstreamMasterDocument>({
    defaultValues: EmptyWorkstreamMasterDocument,
    resolver: yupResolver(schema),
    shouldFocusError: false,
  });

  const fileUploadRef = useRef<FileUpload>(null);

  const onHide = () => {
    setFile(null);
    props.hideDialog();
    reset(EmptyWorkstreamMasterDocument);
  };

  const fileUploade = async (event: FileUploadHandlerParam) => {
    if (event.files[0].size > 1024000) {
      props.toast.current.show({ severity: "error", content: "Document should be less than 2 MB." });
      event.options.clear();
    } else {
      props.toast.current.show({ severity: "success", content: "Document Selected." });
      const file = event.files[0];
      setFile(file);
    }
  };

  const clearForm = () => {
    reset(EmptyWorkstreamMasterDocument);
    setFile(null);
    fileUploadRef.current?.clear();
  };

  const onSubmit = async (data: any) => {
    try {
      if (props.singleData?.id) {
        const body = {
          id: props.singleData.id,
          title: data.title,
          doc_Description: data.doc_Description ?? "",
          workstream_Category_ID: data.workstream_Category_ID,
        };

        const response = await Fetch("TenderWorkstream/UpdateWorkStreamMasterDocument", "PUT", body, null, props.toast);

        if (response?.ok) {
          props.toast.current.show({ severity: "success", summary: "Success", detail: "Document Updated Successfully", life: 3000 });
          props.setReload(!props.reload);
          onHide();
        }

        return;
      }

      if (!file) {
        props.toast.current.show({ severity: "error", detail: "Please select a document." });
        return;
      }
      setLoading(true);

      const formData = new FormData();

      formData.append("Title", data.title);
      formData.append("Doc_Description", data.doc_Description ?? "");
      formData.append("Workstream_Category_ID", String(data.workstream_Category_ID));

      if (file) {
        formData.append("Document", file);
      }

      const response = await fetch(`${baseUrl}TenderWorkstream/WorkStreamMasterDocument`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
        },
        body: formData,
      });

      if (response.ok) {
        props.toast.current.show({ severity: "success", summary: "Success", detail: "Document Uploaded Successfully", life: 3000 });
        // clearForm();
        props.setReload(!props.reload);
        onHide();
      } else {
        const msg = await response.text();
        props.toast.current.show({ severity: "error", summary: "Error", detail: msg, life: 3000 });
      }
      setLoading(false);
    } catch {
      setLoading(false);
      props.toast?.current?.show({ severity: "error", summary: "Error", detail: "Something went wrong", life: 3000 });
    } finally {
      setLoading(false);
    }
  };

  const loadCategories = async () => {
    const response = await Fetch("Tender_Mast/TenderWorkStreamCategoryDropdown", "GET", null, null, props.toast);
    if (response?.ok) {
      const data = await response.json();
      setCategories(data);
    }
  };
  useEffect(() => {
    loadCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log("Description from props:", props.singleData?.doc_Description);

    if (!props.open) return;

    if (props.singleData?.id) {
      reset({
        ...props.singleData,
        title: props.singleData.title ?? "",
        workstream_Category_ID: props.singleData.workstream_Category_ID,
      });
    } else {
      reset(EmptyWorkstreamMasterDocument);
      setFile(null);
    }
  }, [props.open, props.singleData, reset]);

  return (
    <>
      <Dialog visible={props.open} style={{ width: "80vw" }} header={props.singleData?.id ? "Edit Document" : "Add Workstream Master Document"} modal className="p-fluid" onHide={onHide}>
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
          <JVDropdown required column={3} label="Work Stream Category" control={control} name="workstream_Category_ID" options={categories} optionLabel="category_Name" optionValue="id" placeholder="Select Category" error={errors.workstream_Category_ID?.message} />
          <JVInput required column={6} label="Document Title" control={control} name="title" error={errors.title?.message} />
          <div className="field col-12 md:col-6">
            <label htmlFor="file">
              WorkStream Document <span style={{ color: "red" }}>*</span>
            </label>
            <FileUpload ref={fileUploadRef} chooseLabel="Choose Document" mode="basic" name="file" accept="*" maxFileSize={10000000} auto customUpload uploadHandler={fileUploade} disabled={!!props.singleData?.id} />
          </div>
          <div className="field col-12">
            <label>Description</label>
            <Controller name="doc_Description" control={control} render={({ field }) => <InputTextarea {...field} rows={4} className="w-full" placeholder="Enter description" />} />
          </div>

          <div className="col-12 flex justify-content-end gap-2">
            <Button label="Save" icon="pi pi-save" type="submit" loading={loading} disabled={!isDirty} />
            <Button label="Clear" icon="pi pi-times" type="button" className="p-button-secondary" onClick={clearForm} />
          </div>
        </form>
      </Dialog>
    </>
  );
};
